import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ActiveUserAvatar,
  ModalCloseButton,
  RootDrawerToggle,
  Stack as ViewStack,
  createStackHeaderNavigator,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { Logo } from "../../../../components/Logo/Logo";
import { PhotoImageRootParamList } from "../../../../types";
import { BarcodeScannerRootScreen } from "../../../barcode-scanner/screens";
import { PermissionsModalRootScreen } from "../../../permission/screens";
import { SelectUploadImageProvider } from "../../components";
import { ImagesSentSuccessProvider } from "../../components/ImagesSentSuccessProvider";
import { ImagesSentSuccessPartialScreen } from "../ImagesSentSuccessPartialScreen";
import { ImagesSentSuccessScreen } from "../ImagesSentSuccessScreen";
import { ProductImageDeleteScreen } from "../ProductImageDeleteScreen";
import { ProductImageDetailsRootScreen } from "../ProductImageDetailsRootScreen";
import { SelectProductForUtilityScreen } from "../SelectProductForUtilityScreen";
import { SelectUploadRetailerImageMethodScreen } from "../SelectUploadRetailerImageMethodScreen";

export interface PhotoImageRootScreenProps {}

export const PhotoImageRootScreen = ({}: PhotoImageRootScreenProps) => {
  const { t } = useTranslation();
  const Stack = createStackHeaderNavigator<PhotoImageRootParamList>();
  const { colors } = useThemeProvider();

  const transparentScreenOptions = {
    headerStyle: {
      backgroundColor: colors.surface,
    },
    cardStyle: {
      backgroundColor: "transparent",
    },
    headerShown: false,
    animationEnabled: true,
    presentation: "transparentModal",
    cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
  } as const;

  // default handlers define the default behaviour when app is opened initially to ImagesSentSuccessPartialScreen
  const imagesSentSuccessHandlers = {
    onTakeMore: (nav: any) => nav.goBack(),
    onNewProduct: (nav: any) => nav.pop(2),
    onFinished: (nav: any) => nav.pop(3),
  };

  return (
    <SelectUploadImageProvider>
      <ImagesSentSuccessProvider defaultHandlers={imagesSentSuccessHandlers}>
        <Stack.Navigator
          detachInactiveScreens={true}
          screenOptions={{
            title: "",
            headerLeft: () => <RootDrawerToggle />,
          }}
        >
          <Stack.Group
            screenOptions={{
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => (
                <ViewStack centerVertical>
                  <RootDrawerToggle />
                  <Logo />
                </ViewStack>
              ),
              headerRight: () => <ActiveUserAvatar />,
            }}
          >
            <Stack.Screen
              name="SelectProductForUtilityScreen"
              component={SelectProductForUtilityScreen}
              options={{
                headerShown: true,
              }}
            />
            <Stack.Screen
              name="SelectUploadRetailerImageMethodScreen"
              component={SelectUploadRetailerImageMethodScreen}
              options={{
                headerShown: false,
                cardStyle: { height: "100%", backgroundColor: "#000" },
              }}
            />
            <Stack.Screen
              name="ImagesSentSuccessPartialScreen"
              component={ImagesSentSuccessPartialScreen}
              options={transparentScreenOptions}
            />
            <Stack.Screen
              name="ProductImageDetailsRootScreen"
              component={ProductImageDetailsRootScreen}
              options={{
                headerShown: false,
              }}
            />
          </Stack.Group>
          <Stack.Group
            screenOptions={{
              presentation: "modal",
              headerLeft: () => <ModalCloseButton />,
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forVerticalIOS,
              headerShown: true,
            }}
          >
            <Stack.Screen
              name="ImagesSentSuccessScreen"
              component={ImagesSentSuccessScreen}
            />
            <Stack.Screen
              name="ProductImageDeleteScreen"
              component={ProductImageDeleteScreen}
            />
            <Stack.Screen
              name="BarcodeScannerRootScreen"
              component={BarcodeScannerRootScreen}
              options={{ headerShown: false }}
            />
          </Stack.Group>
          <Stack.Group screenOptions={transparentScreenOptions}>
            <Stack.Screen
              name="PermissionsModalRootScreen"
              component={PermissionsModalRootScreen}
            />
          </Stack.Group>
        </Stack.Navigator>
      </ImagesSentSuccessProvider>
    </SelectUploadImageProvider>
  );
};
